<template>
  <div
    v-if="isCountExist"
    class="items-count"
  >
    <BaseSubHeading
      size="small"
      weight="600"
      color="monochrome-05"
      darkColor="monochrome-04"
      className="items-count__label"
    >
      {{ modifierCount }}
    </BaseSubHeading>

    <DotNotification
      v-if="notify"
      class="items-count__indicator"
    />
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Prop } from "vue-property-decorator"
import DotNotification from "@/components/Dot/DotNotification.vue"

const components = {
  DotNotification,
}

@Options({
  name: "Count",
  components,
})
export default class extends Vue {
  @Prop({ default: false }) readonly notify: boolean
  @Prop({ default: 0 }) readonly number: string | number

  get modifierCount() {
    if (Number(this.number) > 99) return "99+"

    return this.number
  }

  get isCountExist() {
    const count = Number(this.number)

    if (isNaN(count)) return false

    return count > 0
  }
}
</script>
